import React, { FC } from 'react';

import useAppDispatch from '../../../../hooks/common/useAppDispatch';
import useAppSelector from '../../../../hooks/common/useAppSelector';
import { hideModal } from '../../../../redux/actions';
import { modalDataSelector } from '../../../../redux/selectors';
import Button from '../../ui-kit/Button';
import TemplateModal from '../TemplateModal';
import './ConfirmCertificateModal.scss';

const ConfirmCertificateModal: FC = () => {
  const dispatch = useAppDispatch();
  const { onConfirm, onCancel, testName, newStatus, testDateTime } =
    useAppSelector(modalDataSelector);

  const handleConfirm = () => {
    onConfirm?.();
    dispatch(hideModal());
  };

  const handleCancel = () => {
    onCancel?.();
    dispatch(hideModal());
  };

  const message = newStatus
    ? `Вы действительно хотите зачесть сертификат для теста "${testName}"?${
        testDateTime
          ? `\n\n Это приведет к отмене записи на экзамен ${testDateTime}.`
          : ''
      }`
    : `Вы действительно хотите отменить применение сертификата для теста "${testName}"?`;
  return (
    <TemplateModal title="Подтверждение действия">
      <div className="confirm-certificate-modal__content">
        <p>{message}</p>

        <div className="confirm-certificate-modal__actions">
          <Button theme="success" onClick={handleConfirm}>
            Подтвердить
          </Button>
          <Button onClick={handleCancel}>Отмена</Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default ConfirmCertificateModal;
